import { defaultTransition, circInOutFast, easeInOut } from './transitions';

export const scaleInOut = {
    exit: {
        scale: 0.5,
        opacity: 0,
        transition: defaultTransition,
    },
    initial: {
        scale: 0.5,
        opacity: 0,
        transition: defaultTransition,
    },
    animate: {
        scale: 1,
        opacity: 1,
        transition: defaultTransition,
    },
};

export const shiftOutwards = {
    exit: {
        y: 30,
        scale: 0.5,
        opacity: 0,
        transition: defaultTransition,
    },
    initial: {
        y: 30,
        scale: 0.5,
        opacity: 0,
        transition: defaultTransition,
    },
    animate: {
        y: 0,
        scale: 1,
        opacity: 1,
        transition: defaultTransition,
    },
};

export const scaleOutIn = {
    exit: {
        scale: 0.5,
        opacity: 0,
        transition: defaultTransition,
    },
    initial: {
        scale: 0.5,
        opacity: 0,
        transition: defaultTransition,
    },
    animate: {
        scale: 1,
        opacity: 1,
        transition: defaultTransition,
    },
};

export const slideInOutRightToLeft = {
    initial: {
        x: 30,
        opacity: 0,
    },
    animate: {
        x: 0,
        opacity: 1,
        transition: {
            ...defaultTransition,
            delay: 0.05,
        },
    },
    exit: {
        x: -30,
        opacity: 0,
        transition: {
            ...defaultTransition,
            delay: 0.05,
        },
    },
};

export const slideInOutTopToBottom = {
    initial: {
        y: -30,
        opacity: 0,
    },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            ...defaultTransition,
            delay: 0.05,
        },
    },
    exit: {
        y: 30,
        opacity: 0,
        transition: {
            ...defaultTransition,
            delay: 0.05,
        },
    },
};

export const fadeInOut = {
    exit: {
        opacity: 0,
        transition: defaultTransition,
    },
    initial: {
        opacity: 0,
        transition: defaultTransition,
    },
    animate: {
        opacity: 1,
        transition: defaultTransition,
    },
};

export const easeInOutAnimation = {
    exit: {
        opacity: 0,
        transition: easeInOut,
    },
    initial: {
        opacity: 0,
        transition: easeInOut,
    },
    animate: {
        opacity: 1,
        transition: easeInOut,
    },
};


export const fadeInOutFavorite = {
    ...fadeInOut,
    exit: {
        opacity: 0,
        transition: {
            ...circInOutFast
        }
    }
}
